import { render, staticRenderFns } from "./PatientMessageForm.vue?vue&type=template&id=0530dc49"
import script from "./PatientMessageForm.vue?vue&type=script&lang=js"
export * from "./PatientMessageForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports